import { showToast, toastTypes } from '../lib/boostrap/toast';

export const copyToClipboard = async (value, message) => {
  const clipboard = window.navigator?.clipboard;
  if (clipboard) {
    await clipboard.writeText(value);
    showToast(toastTypes.SUCCESS, message);
  }
};
